<template>
  <div class="btn-group d-inline-flex flex-shrink-0">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.btn-group .icon-button {
  border-radius: 0;
  transition: none;
  flex-shrink: 0;
}

.btn-group .icon-button:first-child {
  border-top-left-radius: 15%;
  border-bottom-left-radius: 15%;
}

.btn-group .icon-button:last-child {
  border-top-right-radius: 15%;
  border-bottom-right-radius: 15%;
}
</style>
